import { cn } from 'utils/cn';

type Props = {
    active?: boolean;
    completed?: boolean;
    className?: string;
    /** Draws a short line out of the dot's left side, tying the first and last sub-step to the step above. */
    withLeadingLine?: boolean;
};

/** A step's dot: filled once the step is reached. */
export default function StepIcon({ active, completed, className, withLeadingLine }: Props) {
    const isReached = completed || active;
    return (
        <div className={cn('flex items-center', className)}>
            <div className={cn('relative size-[9px] rounded-full', isReached ? 'bg-fg' : 'bg-grey-200')}>
                {withLeadingLine ? (
                    <span
                        className={cn(
                            'absolute top-[calc(50%-1px)] right-full h-px w-3',
                            isReached ? 'bg-fg' : 'bg-divider'
                        )}
                    />
                ) : null}
            </div>
        </div>
    );
}
